import { property } from '@wonderlandengine/api/decorators.js';
import { Component, Material } from '@wonderlandengine/api';

/**
 * Paint Description:
 */
export class PaintDescription extends Component {
	static TypeName = 'paint-description';

	//-----------------------------------------------------------------------------------------
	// Inspector Variables:
	//-----------------------------------------------------------------------------------------

	@property.string('')
	paintId: string = '';

	@property.material()
	paintMaterial: Material | null = null;
}